module.exports={
  "SilverDecisions": "1.1.0",
  "buildTimestamp": 1739278044471,
  "savetime": "2025-09-10T13:41:10.428Z",
  "lng": "en",
  "viewMode": "criterion1",
  "rule": "expected-value-maximization",
  "title": "Step 12 - LegalCases",
  "description": "",
  "format": {
    "locales": "en",
    "payoff1": {
      "style": "currency",
      "currency": "USD",
      "currencyDisplay": "symbol",
      "minimumFractionDigits": 0,
      "maximumFractionDigits": 0,
      "useGrouping": true
    },
    "payoff2": {
      "style": "percent",
      "currency": "USD",
      "currencyDisplay": "symbol",
      "minimumFractionDigits": 0,
      "maximumFractionDigits": 0,
      "useGrouping": true
    },
    "probability": {
      "style": "percent",
      "minimumFractionDigits": 0,
      "maximumFractionDigits": 0,
      "useGrouping": true
    }
  },
  "treeDesigner": {
    "margin": {
      "left": 650,
      "right": 500,
      "top": 200,
      "bottom": 100
    },
    "scale": 1,
    "lng": "en",
    "layout": {
      "type": "cluster",
      "nodeSize": 22,
      "limitNodePositioning": true,
      "limitTextPositioning": true,
      "gridHeight": 95,
      "gridWidth": 160,
      "edgeSlantWidthMax": 0
    },
    "fontFamily": "sans-serif",
    "fontSize": "12px",
    "fontWeight": "normal",
    "fontStyle": "normal",
    "node": {
      "strokeWidth": "2px",
      "optimal": {
        "stroke": "#006f00",
        "strokeWidth": "2px"
      },
      "label": {
        "fontSize": "1em",
        "color": "black"
      },
      "payoff": {
        "fontSize": "1em",
        "color": "black",
        "negativeColor": "#b60000"
      },
      "decision": {
        "fill": "#ff7777",
        "stroke": "#660000",
        "selected": {
          "fill": "#aa3333"
        }
      },
      "chance": {
        "fill": "#ffff44",
        "stroke": "#666600",
        "selected": {
          "fill": "#aaaa00"
        }
      },
      "terminal": {
        "fill": "#44ff44",
        "stroke": "black",
        "selected": {
          "fill": "#00aa00"
        },
        "payoff": {
          "fontSize": "1em",
          "color": "black",
          "negativeColor": "#b60000"
        }
      }
    },
    "edge": {
      "stroke": "#424242",
      "strokeWidth": "1.5",
      "optimal": {
        "stroke": "#006f00",
        "strokeWidth": "2.4"
      },
      "selected": {
        "stroke": "#045ad1",
        "strokeWidth": "3.5"
      },
      "label": {
        "fontSize": "1em",
        "color": "back"
      },
      "payoff": {
        "fontSize": "1em",
        "color": "black",
        "negativeColor": "#b60000"
      }
    },
    "probability": {
      "fontSize": "1em",
      "color": "#0000d7"
    },
    "title": {
      "fontSize": "16px",
      "fontWeight": "bold",
      "fontStyle": "normal",
      "color": "#000000",
      "margin": {
        "top": 15,
        "bottom": 10
      }
    },
    "description": {
      "show": true,
      "fontSize": "12px",
      "fontWeight": "bold",
      "fontStyle": "normal",
      "color": "#000000",
      "margin": {
        "top": 5,
        "bottom": 10
      }
    },
    "readOnly": false,
    "disableAnimations": false,
    "forceFullEdgeRedraw": false,
    "hideLabels": false,
    "hidePayoffs": false,
    "hideExpectedValues": false,
    "hideProbabilities": false,
    "hideCharts": false,
    "hideTextboxes": false,
    "hideMilestones": false,
    "raw": false,
    "payoffNames": [
      null,
      null
    ],
    "maxPayoffsToDisplay": 1,
    "milestoneNames": [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    ]
  },
  "data": {
    "code": "",
    "expressionScope": {},
    "trees": [
      {
        "computed": {
          "expected-value-maximization": {
            "childrenPayoff": [
              "40000"
            ],
            "payoff": [
              "40000"
            ],
            "optimal": true
          },
          "expected-value-minimization": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "maxi-min": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "maxi-max": {
            "childrenPayoff": [
              "130000"
            ],
            "payoff": [
              "130000"
            ],
            "optimal": true
          },
          "mini-min": {
            "childrenPayoff": [
              "-170000"
            ],
            "payoff": [
              "-170000"
            ],
            "optimal": true
          },
          "mini-max": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "min-max": {
            "childrenPayoff": [
              "0",
              "0"
            ],
            "combinedPayoff": "0",
            "payoff": [
              "0",
              "0"
            ],
            "optimal": true
          },
          "max-min": {
            "childrenPayoff": [
              "40000",
              "0"
            ],
            "combinedPayoff": "40000",
            "payoff": [
              "40000",
              "0"
            ],
            "optimal": true
          },
          "min-min": {
            "childrenPayoff": [
              "0",
              "0"
            ],
            "combinedPayoff": "0",
            "payoff": [
              "0",
              "0"
            ],
            "optimal": true
          },
          "max-max": {
            "childrenPayoff": [
              "40000",
              "0"
            ],
            "combinedPayoff": "40000",
            "payoff": [
              "40000",
              "0"
            ],
            "optimal": true
          }
        },
        "childEdges": [
          {
            "computed": {
              "payoff": [
                "0",
                "0"
              ],
              "expected-value-maximization": {
                "probability": 0,
                "optimal": false
              },
              "expected-value-minimization": {
                "probability": 1,
                "optimal": true
              },
              "maxi-min": {
                "probability": 1,
                "optimal": true
              },
              "maxi-max": {
                "probability": 0,
                "optimal": false
              },
              "mini-min": {
                "probability": 0,
                "optimal": false
              },
              "mini-max": {
                "probability": 1,
                "optimal": true
              },
              "min-max": {
                "probability": 1,
                "optimal": true
              },
              "max-min": {
                "probability": 0,
                "optimal": false
              },
              "min-min": {
                "probability": 1,
                "optimal": true
              },
              "max-max": {
                "probability": 0,
                "optimal": false
              }
            },
            "name": "Settle",
            "payoff": [
              0,
              0
            ],
            "childNode": {
              "computed": {
                "expected-value-maximization": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "payoff": [
                    "0"
                  ]
                },
                "expected-value-minimization": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "maxi-min": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "maxi-max": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "payoff": [
                    "0"
                  ]
                },
                "mini-min": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "payoff": [
                    "0"
                  ]
                },
                "mini-max": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "min-max": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                },
                "max-min": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ]
                },
                "min-min": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                },
                "max-max": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ]
                }
              },
              "childEdges": [],
              "name": "Cost: $X",
              "code": "",
              "expressionScope": {},
              "folded": false,
              "location": {
                "x": 331,
                "y": 11
              },
              "type": "terminal",
              "expectedValue": 0,
              "p10": 0,
              "p90": 0
            },
            "expectedValue": 0,
            "p10": 0,
            "p90": 0,
            "optimal": false
          },
          {
            "computed": {
              "payoff": [
                "0",
                "0"
              ],
              "expected-value-maximization": {
                "probability": 1,
                "optimal": true
              },
              "expected-value-minimization": {
                "probability": 0,
                "optimal": false
              },
              "maxi-min": {
                "probability": 0,
                "optimal": false
              },
              "maxi-max": {
                "probability": 1,
                "optimal": true
              },
              "mini-min": {
                "probability": 1,
                "optimal": true
              },
              "mini-max": {
                "probability": 0,
                "optimal": false
              },
              "min-max": {
                "probability": 0,
                "optimal": false
              },
              "max-min": {
                "probability": 1,
                "optimal": true
              },
              "min-min": {
                "probability": 0,
                "optimal": false
              },
              "max-max": {
                "probability": 1,
                "optimal": true
              }
            },
            "name": "Go to Court",
            "payoff": [
              0,
              0
            ],
            "childNode": {
              "computed": {
                "expected-value-maximization": {
                  "childrenPayoff": [
                    "40000"
                  ],
                  "payoff": [
                    "40000"
                  ],
                  "optimal": true
                },
                "expected-value-minimization": {
                  "childrenPayoff": [
                    "40000"
                  ],
                  "payoff": [
                    "40000"
                  ]
                },
                "maxi-min": {
                  "childrenPayoff": [
                    "-170000"
                  ],
                  "payoff": [
                    "-170000"
                  ]
                },
                "maxi-max": {
                  "childrenPayoff": [
                    "130000"
                  ],
                  "payoff": [
                    "130000"
                  ],
                  "optimal": true
                },
                "mini-min": {
                  "childrenPayoff": [
                    "-170000"
                  ],
                  "payoff": [
                    "-170000"
                  ],
                  "optimal": true
                },
                "mini-max": {
                  "childrenPayoff": [
                    "130000"
                  ],
                  "payoff": [
                    "130000"
                  ]
                },
                "min-max": {
                  "childrenPayoff": [
                    "40000",
                    "0"
                  ],
                  "combinedPayoff": "-40000",
                  "payoff": [
                    "40000",
                    "0"
                  ]
                },
                "max-min": {
                  "childrenPayoff": [
                    "40000",
                    "0"
                  ],
                  "combinedPayoff": "40000",
                  "payoff": [
                    "40000",
                    "0"
                  ],
                  "optimal": true
                },
                "min-min": {
                  "childrenPayoff": [
                    "40000",
                    "0"
                  ],
                  "combinedPayoff": "-40000",
                  "payoff": [
                    "40000",
                    "0"
                  ]
                },
                "max-max": {
                  "childrenPayoff": [
                    "40000",
                    "0"
                  ],
                  "combinedPayoff": "40000",
                  "payoff": [
                    "40000",
                    "0"
                  ],
                  "optimal": true
                }
              },
              "childEdges": [
                {
                  "computed": {
                    "payoff": [
                      "130000",
                      "0"
                    ],
                    "probability": "7/10",
                    "expected-value-maximization": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "expected-value-minimization": {
                      "probability": "7/10"
                    },
                    "maxi-min": {
                      "probability": 0
                    },
                    "maxi-max": {
                      "probability": 1,
                      "optimal": true
                    },
                    "mini-min": {
                      "probability": 0,
                      "optimal": false
                    },
                    "mini-max": {
                      "probability": 1
                    },
                    "min-max": {
                      "probability": "7/10"
                    },
                    "max-min": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "min-min": {
                      "probability": "7/10"
                    },
                    "max-max": {
                      "probability": "7/10",
                      "optimal": true
                    }
                  },
                  "name": "Win case",
                  "probability": ".7",
                  "payoff": [
                    "130000",
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "aggregatedPayoff": [
                          "130000"
                        ],
                        "probabilityToEnter": "7/10",
                        "payoff": [
                          "130000"
                        ],
                        "optimal": true
                      },
                      "expected-value-minimization": {
                        "aggregatedPayoff": [
                          "130000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "130000"
                        ]
                      },
                      "maxi-min": {
                        "aggregatedPayoff": [
                          "130000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "130000"
                        ]
                      },
                      "maxi-max": {
                        "aggregatedPayoff": [
                          "130000"
                        ],
                        "probabilityToEnter": "1",
                        "payoff": [
                          "130000"
                        ],
                        "optimal": true
                      },
                      "mini-min": {
                        "aggregatedPayoff": [
                          "130000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "130000"
                        ]
                      },
                      "mini-max": {
                        "aggregatedPayoff": [
                          "130000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "130000"
                        ]
                      },
                      "min-max": {
                        "aggregatedPayoff": [
                          "130000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "-130000",
                        "payoff": [
                          "130000",
                          "0"
                        ]
                      },
                      "max-min": {
                        "aggregatedPayoff": [
                          "130000",
                          "0"
                        ],
                        "probabilityToEnter": "7/10",
                        "combinedPayoff": "130000",
                        "payoff": [
                          "130000",
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-min": {
                        "aggregatedPayoff": [
                          "130000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "-130000",
                        "payoff": [
                          "130000",
                          "0"
                        ]
                      },
                      "max-max": {
                        "aggregatedPayoff": [
                          "130000",
                          "0"
                        ],
                        "probabilityToEnter": "7/10",
                        "combinedPayoff": "130000",
                        "payoff": [
                          "130000",
                          "0"
                        ],
                        "optimal": true
                      }
                    },
                    "childEdges": [],
                    "name": "Gain: $Y",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 331,
                      "y": 125
                    },
                    "type": "terminal",
                    "expectedValue": 130000,
                    "p10": 130000,
                    "p90": 130000
                  },
                  "expectedValue": 130000,
                  "p10": 130000,
                  "p90": 130000,
                  "optimal": true
                },
                {
                  "computed": {
                    "payoff": [
                      "-170000",
                      "0"
                    ],
                    "probability": "3/10",
                    "expected-value-maximization": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "expected-value-minimization": {
                      "probability": "3/10"
                    },
                    "maxi-min": {
                      "probability": 1
                    },
                    "maxi-max": {
                      "probability": 0,
                      "optimal": false
                    },
                    "mini-min": {
                      "probability": 1,
                      "optimal": true
                    },
                    "mini-max": {
                      "probability": 0
                    },
                    "min-max": {
                      "probability": "3/10"
                    },
                    "max-min": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "min-min": {
                      "probability": "3/10"
                    },
                    "max-max": {
                      "probability": "3/10",
                      "optimal": true
                    }
                  },
                  "name": "Lose case",
                  "probability": "#",
                  "payoff": [
                    "-170000",
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "aggregatedPayoff": [
                          "-170000"
                        ],
                        "probabilityToEnter": "3/10",
                        "payoff": [
                          "-170000"
                        ],
                        "optimal": true
                      },
                      "expected-value-minimization": {
                        "aggregatedPayoff": [
                          "-170000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-170000"
                        ]
                      },
                      "maxi-min": {
                        "aggregatedPayoff": [
                          "-170000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-170000"
                        ]
                      },
                      "maxi-max": {
                        "aggregatedPayoff": [
                          "-170000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-170000"
                        ]
                      },
                      "mini-min": {
                        "aggregatedPayoff": [
                          "-170000"
                        ],
                        "probabilityToEnter": "1",
                        "payoff": [
                          "-170000"
                        ],
                        "optimal": true
                      },
                      "mini-max": {
                        "aggregatedPayoff": [
                          "-170000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-170000"
                        ]
                      },
                      "min-max": {
                        "aggregatedPayoff": [
                          "-170000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "170000",
                        "payoff": [
                          "-170000",
                          "0"
                        ]
                      },
                      "max-min": {
                        "aggregatedPayoff": [
                          "-170000",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "-170000",
                        "payoff": [
                          "-170000",
                          "0"
                        ],
                        "optimal": true
                      },
                      "min-min": {
                        "aggregatedPayoff": [
                          "-170000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "170000",
                        "payoff": [
                          "-170000",
                          "0"
                        ]
                      },
                      "max-max": {
                        "aggregatedPayoff": [
                          "-170000",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "-170000",
                        "payoff": [
                          "-170000",
                          "0"
                        ],
                        "optimal": true
                      }
                    },
                    "childEdges": [],
                    "name": "Cost: $Z",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 331,
                      "y": 220
                    },
                    "type": "terminal",
                    "expectedValue": -170000,
                    "p10": -170000,
                    "p90": -170000
                  },
                  "expectedValue": -170000,
                  "p10": -170000,
                  "p90": -170000,
                  "optimal": true
                }
              ],
              "name": "Risk",
              "code": "",
              "expressionScope": {},
              "folded": false,
              "location": {
                "x": 171,
                "y": 172.50000000000003
              },
              "type": "chance",
              "expectedValue": 40000,
              "p10": -170000,
              "p90": 130069
            },
            "expectedValue": 0,
            "p10": 0,
            "p90": 0,
            "optimal": true
          }
        ],
        "name": "Settle or \ngo to Court",
        "code": "",
        "expressionScope": {},
        "folded": false,
        "location": {
          "x": 11,
          "y": 91.75000000000001
        },
        "type": "decision",
        "expectedValue": 40000,
        "p10": -170000,
        "p90": 130069
      },
      {
        "computed": {
          "expected-value-maximization": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "expected-value-minimization": {
            "childrenPayoff": [
              "-140000"
            ],
            "payoff": [
              "-140000"
            ],
            "optimal": true
          },
          "maxi-min": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "maxi-max": {
            "childrenPayoff": [
              "70000"
            ],
            "payoff": [
              "70000"
            ],
            "optimal": true
          },
          "mini-min": {
            "childrenPayoff": [
              "-230000"
            ],
            "payoff": [
              "-230000"
            ],
            "optimal": true
          },
          "mini-max": {
            "childrenPayoff": [
              "0"
            ],
            "payoff": [
              "0"
            ],
            "optimal": true
          },
          "min-max": {
            "childrenPayoff": [
              "-140000",
              "0"
            ],
            "combinedPayoff": "140000",
            "payoff": [
              "-140000",
              "0"
            ],
            "optimal": true
          },
          "max-min": {
            "childrenPayoff": [
              "0",
              "0"
            ],
            "combinedPayoff": "0",
            "payoff": [
              "0",
              "0"
            ],
            "optimal": true
          },
          "min-min": {
            "childrenPayoff": [
              "-140000",
              "0"
            ],
            "combinedPayoff": "140000",
            "payoff": [
              "-140000",
              "0"
            ],
            "optimal": true
          },
          "max-max": {
            "childrenPayoff": [
              "0",
              "0"
            ],
            "combinedPayoff": "0",
            "payoff": [
              "0",
              "0"
            ],
            "optimal": true
          }
        },
        "childEdges": [
          {
            "computed": {
              "payoff": [
                "0",
                "0"
              ],
              "expected-value-maximization": {
                "probability": 1,
                "optimal": true
              },
              "expected-value-minimization": {
                "probability": 0,
                "optimal": false
              },
              "maxi-min": {
                "probability": 1,
                "optimal": true
              },
              "maxi-max": {
                "probability": 0,
                "optimal": false
              },
              "mini-min": {
                "probability": 0,
                "optimal": false
              },
              "mini-max": {
                "probability": 1,
                "optimal": true
              },
              "min-max": {
                "probability": 0,
                "optimal": false
              },
              "max-min": {
                "probability": 1,
                "optimal": true
              },
              "min-min": {
                "probability": 0,
                "optimal": false
              },
              "max-max": {
                "probability": 1,
                "optimal": true
              }
            },
            "name": "Settle",
            "payoff": [
              0,
              0
            ],
            "childNode": {
              "computed": {
                "expected-value-maximization": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "expected-value-minimization": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "payoff": [
                    "0"
                  ]
                },
                "maxi-min": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "maxi-max": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "payoff": [
                    "0"
                  ]
                },
                "mini-min": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "payoff": [
                    "0"
                  ]
                },
                "mini-max": {
                  "aggregatedPayoff": [
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "payoff": [
                    "0"
                  ],
                  "optimal": true
                },
                "min-max": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ]
                },
                "max-min": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                },
                "min-min": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": 0,
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ]
                },
                "max-max": {
                  "aggregatedPayoff": [
                    "0",
                    "0"
                  ],
                  "probabilityToEnter": "1",
                  "combinedPayoff": "0",
                  "payoff": [
                    "0",
                    "0"
                  ],
                  "optimal": true
                }
              },
              "childEdges": [],
              "name": "Cost: $X",
              "code": "",
              "expressionScope": {},
              "folded": false,
              "location": {
                "x": 331,
                "y": 292
              },
              "type": "terminal",
              "expectedValue": 0,
              "p10": 0,
              "p90": 0
            },
            "expectedValue": 0,
            "p10": 0,
            "p90": 0,
            "optimal": true
          },
          {
            "computed": {
              "payoff": [
                "0",
                "0"
              ],
              "expected-value-maximization": {
                "probability": 0,
                "optimal": false
              },
              "expected-value-minimization": {
                "probability": 1,
                "optimal": true
              },
              "maxi-min": {
                "probability": 0,
                "optimal": false
              },
              "maxi-max": {
                "probability": 1,
                "optimal": true
              },
              "mini-min": {
                "probability": 1,
                "optimal": true
              },
              "mini-max": {
                "probability": 0,
                "optimal": false
              },
              "min-max": {
                "probability": 1,
                "optimal": true
              },
              "max-min": {
                "probability": 0,
                "optimal": false
              },
              "min-min": {
                "probability": 1,
                "optimal": true
              },
              "max-max": {
                "probability": 0,
                "optimal": false
              }
            },
            "name": "Go to Court",
            "payoff": [
              0,
              0
            ],
            "childNode": {
              "computed": {
                "expected-value-maximization": {
                  "childrenPayoff": [
                    "-140000"
                  ],
                  "payoff": [
                    "-140000"
                  ]
                },
                "expected-value-minimization": {
                  "childrenPayoff": [
                    "-140000"
                  ],
                  "payoff": [
                    "-140000"
                  ],
                  "optimal": true
                },
                "maxi-min": {
                  "childrenPayoff": [
                    "-230000"
                  ],
                  "payoff": [
                    "-230000"
                  ]
                },
                "maxi-max": {
                  "childrenPayoff": [
                    "70000"
                  ],
                  "payoff": [
                    "70000"
                  ],
                  "optimal": true
                },
                "mini-min": {
                  "childrenPayoff": [
                    "-230000"
                  ],
                  "payoff": [
                    "-230000"
                  ],
                  "optimal": true
                },
                "mini-max": {
                  "childrenPayoff": [
                    "70000"
                  ],
                  "payoff": [
                    "70000"
                  ]
                },
                "min-max": {
                  "childrenPayoff": [
                    "-140000",
                    "0"
                  ],
                  "combinedPayoff": "140000",
                  "payoff": [
                    "-140000",
                    "0"
                  ],
                  "optimal": true
                },
                "max-min": {
                  "childrenPayoff": [
                    "-140000",
                    "0"
                  ],
                  "combinedPayoff": "-140000",
                  "payoff": [
                    "-140000",
                    "0"
                  ]
                },
                "min-min": {
                  "childrenPayoff": [
                    "-140000",
                    "0"
                  ],
                  "combinedPayoff": "140000",
                  "payoff": [
                    "-140000",
                    "0"
                  ],
                  "optimal": true
                },
                "max-max": {
                  "childrenPayoff": [
                    "-140000",
                    "0"
                  ],
                  "combinedPayoff": "-140000",
                  "payoff": [
                    "-140000",
                    "0"
                  ]
                }
              },
              "childEdges": [
                {
                  "computed": {
                    "payoff": [
                      "70000",
                      "0"
                    ],
                    "probability": "3/10",
                    "expected-value-maximization": {
                      "probability": "3/10"
                    },
                    "expected-value-minimization": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "maxi-min": {
                      "probability": 0
                    },
                    "maxi-max": {
                      "probability": 1,
                      "optimal": true
                    },
                    "mini-min": {
                      "probability": 0,
                      "optimal": false
                    },
                    "mini-max": {
                      "probability": 1
                    },
                    "min-max": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "max-min": {
                      "probability": "3/10"
                    },
                    "min-min": {
                      "probability": "3/10",
                      "optimal": true
                    },
                    "max-max": {
                      "probability": "3/10"
                    }
                  },
                  "name": "Win case",
                  "probability": ".3",
                  "payoff": [
                    "70000",
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "aggregatedPayoff": [
                          "70000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "70000"
                        ]
                      },
                      "expected-value-minimization": {
                        "aggregatedPayoff": [
                          "70000"
                        ],
                        "probabilityToEnter": "3/10",
                        "payoff": [
                          "70000"
                        ],
                        "optimal": true
                      },
                      "maxi-min": {
                        "aggregatedPayoff": [
                          "70000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "70000"
                        ]
                      },
                      "maxi-max": {
                        "aggregatedPayoff": [
                          "70000"
                        ],
                        "probabilityToEnter": "1",
                        "payoff": [
                          "70000"
                        ],
                        "optimal": true
                      },
                      "mini-min": {
                        "aggregatedPayoff": [
                          "70000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "70000"
                        ]
                      },
                      "mini-max": {
                        "aggregatedPayoff": [
                          "70000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "70000"
                        ]
                      },
                      "min-max": {
                        "aggregatedPayoff": [
                          "70000",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "-70000",
                        "payoff": [
                          "70000",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-min": {
                        "aggregatedPayoff": [
                          "70000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "70000",
                        "payoff": [
                          "70000",
                          "0"
                        ]
                      },
                      "min-min": {
                        "aggregatedPayoff": [
                          "70000",
                          "0"
                        ],
                        "probabilityToEnter": "3/10",
                        "combinedPayoff": "-70000",
                        "payoff": [
                          "70000",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-max": {
                        "aggregatedPayoff": [
                          "70000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "70000",
                        "payoff": [
                          "70000",
                          "0"
                        ]
                      }
                    },
                    "childEdges": [],
                    "name": "Gain: $Y",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 331,
                      "y": 406
                    },
                    "type": "terminal",
                    "expectedValue": 70000,
                    "p10": 70000,
                    "p90": 70000
                  },
                  "expectedValue": 70000,
                  "p10": 70000,
                  "p90": 70000,
                  "optimal": false
                },
                {
                  "computed": {
                    "payoff": [
                      "-230000",
                      "0"
                    ],
                    "probability": "7/10",
                    "expected-value-maximization": {
                      "probability": "7/10"
                    },
                    "expected-value-minimization": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "maxi-min": {
                      "probability": 1
                    },
                    "maxi-max": {
                      "probability": 0,
                      "optimal": false
                    },
                    "mini-min": {
                      "probability": 1,
                      "optimal": true
                    },
                    "mini-max": {
                      "probability": 0
                    },
                    "min-max": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "max-min": {
                      "probability": "7/10"
                    },
                    "min-min": {
                      "probability": "7/10",
                      "optimal": true
                    },
                    "max-max": {
                      "probability": "7/10"
                    }
                  },
                  "name": "Lose case",
                  "probability": "#",
                  "payoff": [
                    "-230000",
                    0
                  ],
                  "childNode": {
                    "computed": {
                      "expected-value-maximization": {
                        "aggregatedPayoff": [
                          "-230000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-230000"
                        ]
                      },
                      "expected-value-minimization": {
                        "aggregatedPayoff": [
                          "-230000"
                        ],
                        "probabilityToEnter": "7/10",
                        "payoff": [
                          "-230000"
                        ],
                        "optimal": true
                      },
                      "maxi-min": {
                        "aggregatedPayoff": [
                          "-230000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-230000"
                        ]
                      },
                      "maxi-max": {
                        "aggregatedPayoff": [
                          "-230000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-230000"
                        ]
                      },
                      "mini-min": {
                        "aggregatedPayoff": [
                          "-230000"
                        ],
                        "probabilityToEnter": "1",
                        "payoff": [
                          "-230000"
                        ],
                        "optimal": true
                      },
                      "mini-max": {
                        "aggregatedPayoff": [
                          "-230000"
                        ],
                        "probabilityToEnter": 0,
                        "payoff": [
                          "-230000"
                        ]
                      },
                      "min-max": {
                        "aggregatedPayoff": [
                          "-230000",
                          "0"
                        ],
                        "probabilityToEnter": "7/10",
                        "combinedPayoff": "230000",
                        "payoff": [
                          "-230000",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-min": {
                        "aggregatedPayoff": [
                          "-230000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "-230000",
                        "payoff": [
                          "-230000",
                          "0"
                        ]
                      },
                      "min-min": {
                        "aggregatedPayoff": [
                          "-230000",
                          "0"
                        ],
                        "probabilityToEnter": "7/10",
                        "combinedPayoff": "230000",
                        "payoff": [
                          "-230000",
                          "0"
                        ],
                        "optimal": true
                      },
                      "max-max": {
                        "aggregatedPayoff": [
                          "-230000",
                          "0"
                        ],
                        "probabilityToEnter": 0,
                        "combinedPayoff": "-230000",
                        "payoff": [
                          "-230000",
                          "0"
                        ]
                      }
                    },
                    "childEdges": [],
                    "name": "Cost: $Z",
                    "code": "",
                    "expressionScope": {},
                    "folded": false,
                    "location": {
                      "x": 331,
                      "y": 501
                    },
                    "type": "terminal",
                    "expectedValue": -230000,
                    "p10": -230000,
                    "p90": -230000
                  },
                  "expectedValue": -230000,
                  "p10": -230000,
                  "p90": -230000,
                  "optimal": false
                }
              ],
              "name": "Risk",
              "code": "",
              "expressionScope": {},
              "folded": false,
              "location": {
                "x": 171,
                "y": 453.5
              },
              "type": "chance",
              "expectedValue": -140000,
              "p10": -230000,
              "p90": 70069
            },
            "expectedValue": 0,
            "p10": 0,
            "p90": 0,
            "optimal": false
          }
        ],
        "name": "Settle or \ngo to Court",
        "code": "",
        "expressionScope": {},
        "folded": false,
        "location": {
          "x": 11,
          "y": 372.75
        },
        "type": "decision",
        "expectedValue": 0,
        "p10": 0,
        "p90": 0
      }
    ],
    "texts": [
      {
        "value": "Z\nO\nP\nA",
        "location": {
          "x": -115.00209045410156,
          "y": 213.0789794921875
        }
      },
      {
        "value": "From the\nclient’s\nperspective",
        "location": {
          "x": -136.001953125,
          "y": 85.07969665527344
        }
      },
      {
        "value": "From the \nopposing party’s \nperspective",
        "location": {
          "x": -136.00196838378906,
          "y": 363.0781555175781
        }
      },
      {
        "value": "Settlement \nis preferable\n------------------------------------------------------------->\nfor the \nopposing \nparty?",
        "location": {
          "x": -135.00197982788086,
          "y": 453.0777587890625
        }
      }
    ],
    "payoffNames": [],
    "defaultCriterion1Weight": 1,
    "weightLowerBound": 0,
    "weightUpperBound": "Infinity"
  },
  "sensitivityAnalysis": {},
  "definitionsDialog": {
    "valueList": [
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      },
      {
        "name": null,
        "value": "",
        "low": null,
        "high": null,
        "distribution": "constant",
        "error": ""
      }
    ]
  }
}